<div class="button decrement" [class.disabled]="decrementIsDisabled()" (click)="decrement($event)">
  <pxw-icon class="icon minus" icon="minus-sign" [size]="iconSize()"></pxw-icon>
</div>

<input
  #countInput
  class="counter-input"
  type="number"
  inputmode="numeric"
  [attr.value]="count()"
  [min]="min()"
  [max]="max()"
  [disabled]="disabled() || (decrementDisabled() && incrementDisabled())"
  (input)="onInput($event)"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (wheel)="onWheel($event)"
  (click)="onCounterClick($event)"
/>

<div class="button increment" [class.disabled]="incrementIsDisabled()" (click)="increment($event)">
  <pxw-icon class="icon plus" icon="plus-sign" [size]="iconSize()"></pxw-icon>
</div>
